module.exports = __webpack_public_path__ + "static/img/3.f36334c7.png";